import WppFixed from "../wpp/WppFixed";
import Footer from "./Footer";
import Header from "./Header";

export function MainLayout(props: any){
  return (
    <>
      <Header></Header>
      {props.children}
      <Footer></Footer>
      <WppFixed />
    </>
  )
}